import { useUser } from '@clerk/react-router';
import CT from '@marketplace-ai/tags';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs } from '~/components';
import { EmployerAssociationSection } from '~/features/provider/settings/EmployerAssociationSection';
import { AccountSettings } from './AccountSettings';
import { SETTINGS_TABS } from './tabs';
import { useProviderAccountName } from './useProviderAccountName';

const TAGS = CT.providerSettings.tabs;

export const Settings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState<number>(SETTINGS_TABS.account);
  const { user } = useUser();
  const providerName = useProviderAccountName();

  useEffect(() => {
    if (tabParam !== null) {
      setActiveTab(Number.parseInt(tabParam, 10));
    }
  }, [tabParam]);

  const tabs = [
    { name: 'Account', current: activeTab === SETTINGS_TABS.account, cyTag: TAGS.accountTab },
    {
      name: 'Employer Association',
      current: activeTab === SETTINGS_TABS.employerAssociation,
      cyTag: TAGS.employerAssociationTab,
    },
  ];

  return (
    <div className={'grid grid-cols-1 gap-2'}>
      <div className={'w-full'}>
        <div className={classNames('sm:px-6')}>
          <Tabs
            tabs={tabs}
            activeTab={activeTab}
            handleTabChange={(tab) => {
              setActiveTab(tab);
              setSearchParams({ tab: String(tab) });
            }}
          />

          {activeTab === SETTINGS_TABS.account && user && (
            <AccountSettings user={user} providerName={providerName} />
          )}

          {activeTab === SETTINGS_TABS.employerAssociation && <EmployerAssociationSection />}
        </div>
      </div>
    </div>
  );
};
